<template>
    <section aria-label="object-position">
        <div class="table-grid row">
            <div class="col">
                <img
                    v-if="data.image?.fullpath"
                    :src="apiUrl + data.image.fullpath"
                    width="30"
                />
            </div>
            <div class="col">{{ data.name }}</div>
            <div class="col">
                <span class=" pin-position-info green-text">{{ data.pinPosition }}</span>
            </div>
        </div>
    </section>
</template>

<script setup>
import { defineProps } from 'vue'

const apiUrl = process.env.VUE_APP_API_URL

defineProps({
    data: Object,
    item: Object,
    stepsMade: {
        type: Number,
        default: 0
    }
})
</script>

